/**
 * Variant Stock Visibility Handler
 * 
 * Hides quantity selector, stock indicator, and submit buttons
 * when the currently selected variant is out of stock.
 * Skips execution on the Package Builder product page..
 * 
 * Requires:
 * - window.VariantInventory: { [variantId]: inventoryQty }
 * - input[name="id"]: holds the current variant ID
 */

function updateStockUI() {
  // Skip logic on the package builder product
  if (window.location.pathname.includes('package-builder')) return;

  const variantId =
  document.querySelector('select[name="id"]')?.value ||
  document.querySelector('input[name="id"]')?.value;
  const inventoryData = window.VariantInventory;

  if (!variantId || !inventoryData) {
    // Retry if data is not yet available
    return setTimeout(updateStockUI, 200);
  }

  const inventory = inventoryData[variantId];
  const isOutOfStock = typeof inventory === 'number' && inventory <= 0;

    // Hide upsell when base product is out of stock
const upsellBlock = document.querySelector('upsell-product');
if (upsellBlock) {
  upsellBlock.style.display = isOutOfStock ? 'none' : '';
}

  // Out of Stock Message Renderer (generic)
const msgBox = document.getElementById('stock-message');

if (msgBox) {
  if (isOutOfStock) {
msgBox.innerHTML = `
  <div class="stock-message">
    <span class="icon">⚠️</span>
    <span>
      <b>Out of Stock In Your Region.</b> Use Notify Me to be notified when it returns.
    </span>
  </div>
`;
  } else {
    msgBox.innerHTML = "";
  }
}

  const selectors = [
  '.product__submit__add',
  '.product__submit__quick',
  '[data-quantity-selector]',
  '[data-remaining-wrapper]'
  ];

  selectors.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) el.style.display = isOutOfStock ? 'none' : '';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Initial run (with delay to account for variant selector auto-set)
  setTimeout(updateStockUI, 300);

  // Also run when variant is changed via selector
  const selector = document.querySelector('select[name="id"]');
  if (selector) {
    selector.addEventListener('change', updateStockUI);
  }
});